// src/components/pages/Order.js
import React from 'react';
import Checkout from '../features/Cart/Checkout';
import "../features/Cart/Checkout.css";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
const stripePromise = loadStripe('pk_live_51SZhsdHcvLhJFUKBH5JOpw6WL8Dl71UCM11UFfLrcP8ySy4PS5nf0TRuf5m54UjUY7I88WqP2Q3UEchYOrFMxc9200tyNnuLkk');

const Order = () => {
  return (
    <div className='checkoutSection'>
      <Elements stripe={stripePromise}>
        <Checkout />
      </Elements>
    </div>
  );
};

export default Order;